import React from 'react';
import urls, { codeUrl } from '@/constants/urls';
import InfiniteScrollCards from '@/components/cards/InfiniteScrollCards';
import CollectionCardItems from './CollectionCardItems';

const CollectionCards = ({
  canCreate,
  category,
  handleScroll,
  items,
  itemsPerRow,
  newCollectionCode,
  onCheckBoxClick,
  readErrors,
  readStatus,
  single,
}) => (
  <InfiniteScrollCards
    canCreate={canCreate}
    className="aridhia-collection-cards"
    entity="collection"
    handleScroll={handleScroll}
    icon="object group outline"
    items={items}
    itemsPerRow={itemsPerRow}
    loading
    readErrors={readErrors}
    readStatus={[readStatus]}
    url={codeUrl(urls.COLLECTION, newCollectionCode, '#')}
  >
    <CollectionCardItems category={category} items={items} onCheckBoxClick={onCheckBoxClick} single={single} />
  </InfiniteScrollCards>
);

export default CollectionCards;
